import styled from "@emotion/styled";
import { text, surface, controlFontSize, fontSize, spacing } from "@atlas-int/tokens";

export interface DropdownItemStyleProps {
  $highlighted?: boolean;
  $selected?: boolean;
  $alignItems?: string;
  $height?: string;
}

const DropdownItem = styled.div<DropdownItemStyleProps>`
  display: flex;
  align-items: ${({ $alignItems }) => $alignItems ?? "center"};
  height: ${({ $height }) => $height ?? "36px"};
  padding: 0 ${spacing[8]};
  font-size: ${fontSize.base};
  color: ${text.primary};
  cursor: pointer;
  background-color: ${({ $highlighted, $selected }) =>
    $selected || $highlighted ? surface.hover : "transparent"};
`;

export const DropdownItemLabel = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export default DropdownItem;
